module.exports = __webpack_public_path__ + "img/mob1.dd461d44.png";